import { useSearchParams } from 'react-router-dom'
import { useServiceTimetableReport } from '../hooks/useServiceTimetableReport'
import { formatDateRange } from '../lib/dates'
import { PrintShell, usePrintOnReady } from '../components/print/printKit'
import { ServiceTimetableBlock } from './ServiceTimetableDoc'

// ServiceTimetableReport (Feature 2) — browser-print "Timings & Set Plan" across
// events. Route /service-timetable-report. Data comes from ONE batched endpoint
// (/api/reports/service-timetable) rather than firing 3 queries per event, which
// previously overloaded the API and stalled the report mid-render. `?events=1,2,3`
// limits to a chosen subset ("all or specific events").

export function ServiceTimetableReport() {
  const { data } = useServiceTimetableReport()
  const [params] = useSearchParams()
  usePrintOnReady(data != null)

  const only = params.get('events')
  const onlyIds = only ? new Set(only.split(',').map((s) => Number(s.trim())).filter((n) => Number.isFinite(n))) : null

  const events = (data?.events ?? []).filter((e) => (onlyIds ? onlyIds.has(e.eventId) : true))

  return (
    <PrintShell>
      <section style={{ paddingBottom: 12 }}>
        <div style={{ fontSize: 12, color: '#5a5a5a', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>
          NYMR · Special Event Train Services — Timings &amp; Set Plan
        </div>
        <h1 style={{ fontSize: 30 }}>Event Service Timetables</h1>
        <p style={{ fontSize: 12, color: '#5a5a5a' }}>
          {events.length} event{events.length === 1 ? '' : 's'} · Generated {new Date().toLocaleString('en-GB')}
        </p>
      </section>
      {!data && <p style={{ fontStyle: 'italic', color: '#5a5a5a' }}>Loading…</p>}
      {events.map((e) => (
        <ServiceTimetableBlock
          key={e.eventId}
          heading={e.name}
          subtitle={`${e.typeName} · ${formatDateRange(e.startDate, e.endDate)}`}
          services={e.services}
          info={e.info}
        />
      ))}
      {data && events.length === 0 && (
        <p style={{ fontStyle: 'italic', color: '#5a5a5a' }}>No events with a timetable.</p>
      )}
    </PrintShell>
  )
}
